export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID!,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI!,
  },
  cache: {
    cacheLocation: "localStorage", // or "sessionStorage"
    storeAuthStateInCookie: false,
  },
  system: {
    windowHashTimeout: 9000, // Increased from default 6000ms
    iframeHashTimeout: 9000, // Increased from default 6000ms
    loadFrameTimeout: 9000, // Increased from default 6000ms
    asyncPopups: false, // Disable async popups for better reliability
  },
};

export const loginRequest = {
  scopes: [
    import.meta.env.VITE_API_SCOPE
  ],
};
